export default __webpack_public_path__ + "39af5f5b050affef579a8582e4dd9ed1.png";